export enum PAYMENT_GATEWAYS {
  TAP = 1,
  MyFatoorah = 2,
  PAYMOB = 3,
}
